import React from 'react'
import CircularProgress from 'material-ui/CircularProgress';


export default class ResponseMessage extends React.Component {
 	
 	

	render() {
		const messageStyle = {
			fontSize:17,
			lineheight:1,
			marginTop:5,
			flex: 3
		}
		const spinnerStyle ={
			flex: 1
		}

		const props  = this.props
		var spinner = ""

		if(this.props.status == 'pending'){
			spinner = <span style={spinnerStyle}><CircularProgress size={50} thickness={4} /></span> 
		}
		else if(this.props.status == 'success'){
			messageStyle.color = '#02ad02'
		}else if(this.props.status == "error"){
			messageStyle.color = 'red'
		}else{
			messageStyle.color = 'black'
		}
		return <div style={props.style}> 
					<div style={{display:'flex'}}>
						{spinner}
						<div style={messageStyle}>{props.message}</div>
					</div>
				</div>
	}
}


// WEBPACK FOOTER //
// ./src/js/components/ResponseMessage.js